import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';

interface ContractListItemDTO {
  id: string;
  pos: string;
  code: string;
  type: string;
  asset: string;
  product: string;
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
  plan: string;
}
const ContractListItemDTO = {
  create: (initValues?: Partial<ContractListItemDTO>): ContractListItemDTO => {
    const defaults: ContractListItemDTO = {
      id: '',
      pos: '',
      code: '',
      type: '',
      asset: '',
      product: '',
      startDate: null,
      endDate: null,
      plan: '',
    };
    const fixedInitValues: Partial<ContractListItemDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
        startDate: ObjectUtil.ToMoment(initValues.startDate),
        endDate: ObjectUtil.ToMoment(initValues.endDate),
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default ContractListItemDTO;
